const CREDENTIAL_ID_PARAM_KEY = 'credentialId';

export type CredentialParams = Record<typeof CREDENTIAL_ID_PARAM_KEY, string>;

export const CREDENTIAL_ID_KEY = CREDENTIAL_ID_PARAM_KEY;

export const credentialsPath = () => '/settings/credentials' as const;

export const credentialCreateRoute = `${credentialsPath()}/create` as const;

export const credentialCreatePath = () =>
  `${credentialsPath()}/create` as const;

export const credentialDetailRoute =
  `${credentialsPath()}/:${CREDENTIAL_ID_PARAM_KEY}` as const;

export const credentialDetailPath = (credentialId: number) =>
  `${credentialsPath()}/${credentialId}` as const;
